// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import MissionSection from "./components/MissionSection";
import CommentsSection from "./components/CommentsSection";
import Footer from "./components/Footer";
import SignUp from "./components/SignUp";
import SignIn from "./components/SignIn";
import Dashboard from "./components/Dashboard";
import "./styles.css";
import AddSubject from "./components/AddSubjects";
import Admin from "./components/Admin";
import Subjects from "./components/Subjects";
import PersonalProfile from "./components/PersonalProfile";
import ContactUs from "./components/ContactUs";
import MyProfile from "./components/Profile";
import SchoolLevels from "./components/SchoolLevels";
import AddSchoolLevel from "./components/AddSchoolLevel";
import AddTopics from "./components/AddTopics";
import Topics from "./components/Topics";
import ViewTopic from "./components/ViewTopic";
import AdminUsers from "./components/AdminUsers";
import Pricing from "./components/Pricing";
import Subscription from "./components/Subscription";
import ProfileDashboard from "./components/ProfileDashboard";
import EditUser from "./components/EditUser";
import FeaturesSection from "./components/FeaturesSection";
import ResponsePage from "./components/ResponsePage";
import AddPastPapers from "./components/PastPapers/AddPastPapers";
import PastPapers from "./components/PastPapers/PastPapers";
import AddRevisionPapers from "./components/RevisionHub/AddRevisionPapers";
import RevisionHub from "./components/RevisionHub/RevisionHub";
import NewsLetters from "./components/NewsLetters";

// General Protected Route for authenticated users
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  if (!user) {
    console.log("ProtectedRoute: No user, redirecting to /sign-in");
    return <Navigate to="/sign-in" replace />;
  }
  if (!user.emailVerified) {
    console.log("ProtectedRoute: Email not verified, redirecting to /sign-in");
    return <Navigate to="/sign-in" replace />;
  }
  return children;
};

// Admin-only Protected Route
const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  if (!user) return <Navigate to="/sign-in" replace />;
  if (user.role !== 'admin') return <Navigate to="/dashboard" replace />; // Redirect non-admins to dashboard
  return children;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Header/>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={
              <>
                <HeroSection />
                <PersonalProfile />
                <MissionSection />
                <CommentsSection />
              </>
            }
          />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/profile" element={<MyProfile />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/response" element={<ResponsePage />} />
          {/* Protected Routes for all authenticated users */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subjects"
            element={
              <ProtectedRoute>
                <Subjects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/response"
            element={
              <ProtectedRoute>
                <ResponsePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/schoollevels"
            element={
              <ProtectedRoute>
                <SchoolLevels />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics"
            element={
              <ProtectedRoute>
                <Topics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/viewtopic/:topicId"
            element={
              <ProtectedRoute>
                <ViewTopic />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscription"
            element={
              <ProtectedRoute>
                <Subscription />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users/edit/:userId"
            element={
              <ProtectedRoute>
                <EditUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profileDashboard"
            element={
              <ProtectedRoute>
                <ProfileDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminusers"
            element={
              <ProtectedRoute>
                <AdminUsers />
              </ProtectedRoute>
            }
          />

          {/* Admin-only Routes */}
          <Route
            path="/addsubjects"
            element={
              <AdminRoute>
                <AddSubject />
              </AdminRoute>
            }
          />
          <>
            
          </>
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <Admin />
              </AdminRoute>
            }
          />
          <Route
            path="/addschoollevels"
            element={
              <AdminRoute>
                <AddSchoolLevel />
              </AdminRoute>
            }
          />
          <Route
            path="/pastpapers"
            element={
              <AdminRoute>
                <PastPapers />
              </AdminRoute>
            }
          />
          <Route
            path="/addtopics"
            element={
              <AdminRoute>
                <AddTopics />
              </AdminRoute>
            }
          />
          <Route
            path="/addpastpapers"
            element={
              <AdminRoute>
                <AddPastPapers />
              </AdminRoute>
            }
          />
          <Route
            path="/revisionhub"
            element={
              <AdminRoute>
                <RevisionHub />
              </AdminRoute>
            }
          />
          <Route
            path="/addrevisionpapers"
            element={
              <AdminRoute>
                <AddRevisionPapers />
              </AdminRoute>
            }
          />
          <Route
            path="/newsletters"
            element={
              <AdminRoute>
                <NewsLetters />
              </AdminRoute>
            }
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;